import { DomainInitPayload } from '@sxm-de/dev-kits/web-sdk/types';
import { getDefaultBillingProfile } from '../helpers/get-default-billing-profile';
import { updatePhoneNumber } from '../helpers/update-phone-number';
import { UpdateBillingProfilePaymentMethod } from '../helpers/update-billing-profile-payment-method';
import { CreateBillingProfileWithDefaultPaymentMethod } from '../helpers/create-billing-profile-with-default-payment-method';

interface AddPaymentMethodStripeWithNamePhoneAddressFnPayload {
    firstName: string;
    lastName: string;
    phoneNumber: string;
    stripePaymentMethodId: string;
    serviceAddress: {
        addressLine1: string;
        city: string;
        state: string;
        zipCode: string;
        country: string;
    };
}

export type AddPaymentMethodStripeWithNamePhoneAddressFn = (
    payload: AddPaymentMethodStripeWithNamePhoneAddressFnPayload,
) => Promise<unknown>;

export function initAddPaymentMethodStripeWithNamePhoneAddressFn({
    dependencies,
    state,
}: DomainInitPayload): AddPaymentMethodStripeWithNamePhoneAddressFn {
    return async ({
        firstName,
        lastName,
        phoneNumber,
        stripePaymentMethodId,
        serviceAddress,
    }: AddPaymentMethodStripeWithNamePhoneAddressFnPayload) => {
        const { clientSdk } = dependencies;
        state['stripePaymentMethodId'] = stripePaymentMethodId;

        try {
            await updatePhoneNumber({ phoneNumber }, dependencies);
        } catch {
            // silently catch phone number update
        }

        try {
            const { id: billingProfileId } =
                await getDefaultBillingProfile(dependencies);

            await clientSdk.commerce.billing.updateBillingProfile(
                billingProfileId,
                {
                    billingProfileName: {
                        firstAndLastName: {
                            firstName,
                            lastName,
                        },
                    },
                    serviceAddress: {
                        ...serviceAddress,
                        country: serviceAddress.country.toUpperCase(),
                    },
                },
            );

            await UpdateBillingProfilePaymentMethod(
                billingProfileId,
                stripePaymentMethodId,
                dependencies,
            );
        } catch (error: any) {
            await CreateBillingProfileWithDefaultPaymentMethod(
                {
                    firstName,
                    lastName,
                    serviceAddress,
                    stripePaymentMethodId,
                },
                dependencies,
            );
        }
    };
}
